import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import FontStockReturnOrderList from '../entities/back-stockreturnorder'
import UpdateBackAbroadOrderStatu from '@/store/entities/back-order-update-statu'

interface FontStockReturnOrderState extends ListState<FontStockReturnOrderList> {
    //orderInfo: createdata,
    //updateOrdeData: UpdateBackAbroadOrderStatu,
}

class FontAbroadOrderMutations extends ListMutations<FontStockReturnOrderList>{

}
class FontAbroadOrder extends ListModule<FontStockReturnOrderState, any, FontStockReturnOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<FontStockReturnOrderList>(),
        loading: false,
        id: 0
    }
    actions = {
        async getAll(context: ActionContext<FontStockReturnOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontAbroadStockReturn/GetAbroadReturnOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<FontStockReturnOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async comfirmDestroyOrder(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontAbroadStockReturn/ComfirmDestroyOrder?orderReturnId=' + payload.data.orderReturnId );
        },
    };
    mutations = {
        setCurrentPage(state: FontStockReturnOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FontStockReturnOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const fontstockreturnorders = new FontAbroadOrder();
export default fontstockreturnorders;